import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { MenuService } from './../../services/menu.service';
import { Subscription } from 'rxjs';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';


@Component({
  selector: 'app-test-scores',
  templateUrl: './test-scores.component.html',
  styleUrls: ['./test-scores.component.scss']
})
export class TestScoresComponent implements OnInit, OnDestroy {
  @Input() profileId: any;
  currentPageId: number;
  subs: Subscription[] = [];
  selectedIndex = 0;
  constructor(private _menuService: MenuService, 
    private _commonDataSharedService: CommonDataSharedService
    ) { }
  ngOnInit() {
    this.subs.push(
      this._commonDataSharedService.showTabClicked.subscribe(() => {
        this.selectedIndex = 3;
      }),
      this._commonDataSharedService.showTabClickedGPA.subscribe(() => {
        this.selectedIndex = 0;
      }),
      this._commonDataSharedService.showTabClickedSAT.subscribe(() => {
        this.selectedIndex = 4;
      }),
      this._commonDataSharedService.testScoreClicked.subscribe(() => {
        this.selectedIndex = 1;
      })
    );
  }
  getPageData() {
    this.currentPageId = this._menuService.getCurrentPageId();
  }
  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
